<div class="route-schedules-page">
  <div class="templates-pane">
    <div class="templates-grid" *ngFor="let group of routeGroups">
      <h2 class="mt-3 mb-2 route-group-title">{{ group.routeName }}</h2>

      <mat-card *ngFor="let template of group.templates" class="template-card mb-3">
        <mat-card-content>
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h4>{{ template.name }}</h4>
              <div class="template-stats">
                <span class="badge bg-primary me-2">{{ template.slots?.length || 0 }} slots</span>
                <span class="badge bg-secondary me-2" *ngIf="template.assignmentDateFrom && template.assignmentDateTo">
                  {{ template.assignmentDateFrom | date:'yyyy-MM-dd' }} – {{ template.assignmentDateTo | date:'yyyy-MM-dd' }}
                </span>
              </div>
            </div>
            <div class="action-buttons">
              <button *ngIf="canDelete(template, group)" mat-icon-button color="warn" title="Delete"
                (click)="deleteTemplate(template)">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button color="primary" (click)="editTemplate(template)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="accent" title="Duplicate" (click)="duplicateTemplate(template)">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <div class="d-flex justify-content-between align-items-center mt-3 mb-2 special-schedules-header">
        <h4>{{ i18n.specialSchedules | translateAttribute }}</h4>
        <button mat-stroked-button color="primary" [disabled]="!group.routeId" (click)="addOverride(group)">
          <mat-icon>add</mat-icon> {{ i18n.addSpecialSchedule | translateAttribute }}
        </button>
      </div>

      <mat-card *ngFor="let template of group.overrides" class="template-card override-card mb-3">
        <mat-card-content>
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h4>{{ template.name }}</h4>
              <div class="template-stats">
                <span class="badge bg-primary me-2">{{ template.slots?.length || 0 }} slots</span>
                <span class="badge bg-warning me-2">{{ overrideDescription(template) }}</span>
              </div>
            </div>
            <div class="action-buttons">
              <button mat-icon-button color="warn" title="Delete" (click)="deleteTemplate(template)">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button color="primary" (click)="editOverride(template, group)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <p *ngIf="group.overrides.length === 0" class="no-overrides-text">{{ i18n.noSpecialSchedules | translateAttribute }}</p>
    </div>

    <p *ngIf="!loading && templates.length === 0" class="no-templates-text">{{ i18n.noTemplates | translateAttribute }}</p>
  </div>

  <div class="sick-shuttles-pane">
    <h2 class="font-semibold text-xl sick-shuttles-header sick-shuttles-title">
      {{ i18n.sickShuttlesTitle | translateAttribute }} ({{ sickShuttles.length }})
    </h2>

    <div class="sick-shuttles-scroll">
      <table class="sick-shuttles-table" *ngIf="sickShuttleGroups.length > 0">
        <thead>
          <tr>
            <th></th>
            <th class="checkbox-cell"></th>
            <th>{{ i18n.route | translateAttribute }}</th>
            <th>{{ i18n.date | translateAttribute }}</th>
            <th>{{ i18n.time | translateAttribute }}</th>
            <th>{{ i18n.count | translateAttribute }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let group of sickShuttleGroups">
            <tr class="group-row" (click)="toggleSickShuttleGroup(group)">
              <td class="expand-cell">
                <mat-icon>{{ group.expanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
              </td>
              <td class="checkbox-cell" (click)="$event.stopPropagation()">
                <mat-checkbox
                  [checked]="isGroupFullySelected(group)"
                  [indeterminate]="isGroupPartiallySelected(group)"
                  (change)="toggleSelectAllInGroup(group)">
                </mat-checkbox>
              </td>
              <td>{{ group.routeName }}</td>
              <td></td>
              <td>{{ group.time }}</td>
              <td>{{ group.shuttles.length }}</td>
              <td class="resolve-cell">
                <button *ngIf="group.selectedIds.size > 0" mat-stroked-button color="primary"
                  (click)="$event.stopPropagation(); resolveSickShuttleGroup(group)">{{ i18n.resolve | translateAttribute }}</button>
              </td>
            </tr>
            <ng-container *ngIf="group.expanded">
              <tr class="detail-row" *ngFor="let shuttle of group.shuttles">
                <td></td>
                <td></td>
                <td></td>
                <td class="detail-date-cell-content">
                  <mat-checkbox
                    [checked]="isShuttleSelected(group, shuttle)"
                    (change)="toggleShuttleSelection(group, shuttle)">
                  </mat-checkbox>
                  <span>{{ toSwedishDate(shuttle.startDateUtc) }}</span>
                </td>
                <td></td>
                <td></td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>

      <p *ngIf="!sickShuttlesLoading && sickShuttleGroups.length === 0" class="no-sick-shuttles-text">{{ i18n.noSickShuttles | translateAttribute }}</p>
    </div>
  </div>
</div>
